var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarViewWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12838_65042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 3.33341H15V1.66675H13.3333V3.33341H6.66667V1.66675H5V3.33341H4.16667C3.24167 3.33341 2.50833 4.08341 2.50833 5.00008L2.5 16.6667C2.5 17.5834 3.24167 18.3334 4.16667 18.3334H15.8333C16.75 18.3334 17.5 17.5834 17.5 16.6667V5.00008C17.5 4.08341 16.75 3.33341 15.8333 3.33341ZM15.8333 16.6667H4.16667V8.33341H15.8333V16.6667ZM7.5 11.6667H5.83333V10.0001H7.5V11.6667ZM10.8333 11.6667H9.16667V10.0001H10.8333V11.6667ZM14.1667 11.6667H12.5V10.0001H14.1667V11.6667ZM7.5 15.0001H5.83333V13.3334H7.5V15.0001ZM10.8333 15.0001H9.16667V13.3334H10.8333V15.0001ZM14.1667 15.0001H12.5V13.3334H14.1667V15.0001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12838_65042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarViewWhite);
export default __webpack_public_path__ + "static/media/calendar_view_white.20fe16bbaae99750f7ad56d62c4548ad.svg";
export { ForwardRef as ReactComponent };